import { useWorkflowTemplateVersion } from '@commenda/api';
import { useEffect, useRef, useState } from 'react';
import { CanvasStatusBadge } from './CanvasStatusBadge';

export type TCanvasRefreshBadgeProps = {
  workflowTemplateVersionId: string;
};

export const CanvasRefreshBadge = ({
  workflowTemplateVersionId,
}: TCanvasRefreshBadgeProps) => {
  // Shares the SWR key the chat panel polls, so this reads that cache and never drives an interval itself.
  const { data, isValidating, mutate } = useWorkflowTemplateVersion(
    workflowTemplateVersionId
  );

  const [lastUpdatedAt, setLastUpdatedAt] = useState<Date | null>(null);
  const wasValidating = useRef(false);

  // Stamped when a fetch completes rather than when the definition differs, so the badge reports how
  // current the canvas is even on a poll that changed nothing.
  useEffect(() => {
    if (wasValidating.current && !isValidating && data) {
      setLastUpdatedAt(new Date());
    }
    wasValidating.current = isValidating;
  }, [isValidating, data]);

  return (
    <CanvasStatusBadge
      isRefreshing={isValidating}
      lastUpdatedAt={lastUpdatedAt}
      isEditInProgress={false}
      onRefreshNow={() => {
        mutate();
      }}
    />
  );
};
